namespace app.tarefas.minhasTarefas {

    import IDialogService = ng.material.IDialogService;
    import IFilterService = ng.IFilterService;
    
    export class AssigneeGroupController {
        
        public assigneeGroup: IGroup;
        public cmd: AssigneeGroupTasksCommand = new AssigneeGroupTasksCommand();
        
        /** @ngInject **/
        constructor(private $mdDialog: IDialogService, 
                private $filter: IFilterService,
                private minhasTarefasService: MinhasTarefasService,
                private tasks: ITask[], private groups: IGroup[]) { 
           this.cmd.addTasks(tasks);
        }

        public assignGroupTasks(): void {
            this.minhasTarefasService.assignGroupTasks(this.cmd)
                .then(() => {
                    this.tasks.forEach((task) => {
                        task.selected = false;
                        task.assigneeGroup = this.cmd.assigneeGroup;   
                    });
                    this.$mdDialog.hide();
                });
        }
        
        public changeAssigneeGroup(): void {
            if (this.assigneeGroup) {
                this.cmd.assigneeGroup = this.assigneeGroup.id;
            } else {
                this.cmd.assigneeGroup = null;
            }
        }
        
        public closeDialog(): void {
            this.$mdDialog.hide();
        }
        
        public filterGroups(searchText: string): Array<IGroup> {
            return this.$filter("accentInsensitiveOrderBy")(this.$filter("accentInsensitiveFilter")(this.groups, searchText), "value");
        }
        
    }
    
    angular
        .module("app.tarefas.minhas-tarefas")
        .controller("app.tarefas.minhas-tarefas.AssigneeGroupController", AssigneeGroupController);
}